import {
  SLIDE_QR_CAPTION_RESERVE_CQH,
  SLIDE_QR_ZONE,
} from '../../engagements/slides/slideFrame.ts';

/** Fixed scan colors: dark modules on a white field, independent of Stage theme. */
export const STAGE_JOIN_QR_FG_COLOR = '#000000';
export const STAGE_JOIN_QR_BG_COLOR = '#FFFFFF';

/** Matches the current Stage sidebar QR footprint (`windowWidth * 0.17`). */
export const STAGE_JOIN_QR_FOOTPRINT_VW = 0.17;

/**
 * Quiet-zone padding of at least 4 modules on every side.
 * Typical join URLs encode as QR version 4 (33 modules) at level M.
 */
export const STAGE_JOIN_QR_QUIET_ZONE_MODULES = 4;
export const STAGE_JOIN_QR_LAYOUT_MODULES = 33;

/** Shared 2-line caption classes. Tokens must stay space-separated. */
export function stageQrCaptionClassName(freeform: boolean): string {
  return [
    'line-clamp-2',
    'w-full',
    'text-center',
    'font-screen-body',
    freeform ? 'whitespace-normal' : null,
    freeform ? 'leading-[1.25]' : null,
  ]
    .filter((token): token is string => Boolean(token))
    .join(' ');
}

export function qrCodePropsFromFootprint(footprintPx: number) {
  const totalModules =
    STAGE_JOIN_QR_LAYOUT_MODULES + STAGE_JOIN_QR_QUIET_ZONE_MODULES * 2;
  const qrSize = footprintPx * (STAGE_JOIN_QR_LAYOUT_MODULES / totalModules);
  const quietZonePx =
    footprintPx * (STAGE_JOIN_QR_QUIET_ZONE_MODULES / totalModules);

  return {
    size: qrSize,
    fgColor: STAGE_JOIN_QR_FG_COLOR,
    bgColor: STAGE_JOIN_QR_BG_COLOR,
    level: 'M' as const,
    footprintPx,
    quietZonePx,
  };
}

export function getStageJoinQrCodeProps(windowWidth: number) {
  return qrCodePropsFromFootprint(windowWidth * STAGE_JOIN_QR_FOOTPRINT_VW);
}

/**
 * FREEFORM QR tile: fill space left after the 2-line caption reserve, stay
 * square, and never exceed today's 17% slide-width footprint.
 */
export function getFreeformStageQrFootprintPx(
  slideWidth: number,
  slideHeight: number,
  options?: { mutedAppearance?: boolean; hideCta?: boolean },
): number {
  const padX = (options?.mutedAppearance ? 0.012 : 0.015) * slideWidth;
  const padY = (options?.mutedAppearance ? 0.014 : 0.02) * slideHeight;
  const cardW = (SLIDE_QR_ZONE.card.w / 100) * slideWidth;
  const cardH = (SLIDE_QR_ZONE.card.h / 100) * slideHeight;
  const innerW = Math.max(0, cardW - 2 * padX);
  const innerH = Math.max(0, cardH - 2 * padY);
  const captionH = options?.hideCta
    ? 0
    : (SLIDE_QR_CAPTION_RESERVE_CQH / 100) * slideHeight;
  const availH = Math.max(0, innerH - captionH);
  const todayMax = slideWidth * STAGE_JOIN_QR_FOOTPRINT_VW;
  return Math.round(Math.min(todayMax, innerW, availH) * 100) / 100;
}
